import React from 'react';
import { Link } from 'react-router-dom';
import onClickOutside from 'react-onclickoutside';
import { withRender } from 'utils/render';

import {
  HeaderWrapper,
  HeaderCenter,
  Container,
  Logo,
  RightMenu,
  MenuItem,
  MobileMenu,
} from './style';
import { HamburgerMenu } from 'components';

interface State {
  isOpen: boolean,
}

interface Props {
  location?: any,
}

interface RouterProps {
  to: string,
  location?: any,
  onMenuClick: Function,
}

const RouterLink: React.FC<RouterProps> = props => {
  return (
    <Link to={props.to} onClick={() => props.onMenuClick()}>
      <MenuItem isActive={props.to === props.location.pathname}>
        {props.children}  
      </MenuItem>
    </Link>
  );
};

class Header extends React.Component<Props, State> {
  state: State = {
    isOpen: false,
  };

  handleOpen = (): void => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  handleClickOutside = (event: Event) => {
    this.setState({
      isOpen: false,
    });
  }

  render() {
    return (
      <HeaderWrapper>
        <HeaderCenter>
          <Container>
            <Link to='/'>
              <Logo src={require('../../assets/logo.png')} />
            </Link>

            <RightMenu>
              <RouterLink
                to='/'
                {...this.props}
                onMenuClick={this.handleOpen}
              >
                제휴 안내
              </RouterLink>
              <RouterLink
                to='/case'
                {...this.props}
                onMenuClick={this.handleOpen}
              >
                사장님 사례
              </RouterLink>
              <RouterLink
                to='/about'
                {...this.props}
                onMenuClick={this.handleOpen}
              >
                데이트팝 소개
              </RouterLink>
              <RouterLink
                to='/company'
                {...this.props}
                onMenuClick={this.handleOpen}
              >
                회사 소개
              </RouterLink>
              <RouterLink
                to='/contact'
                {...this.props}
                onMenuClick={this.handleOpen}
              >
                제휴 문의
              </RouterLink>
            </RightMenu>

            <HamburgerMenu
              isOpen={this.state.isOpen}
              menuClicked={this.handleOpen}
            />

            <MobileMenu isOpen={this.state.isOpen}>
              <RouterLink
                to='/'
                {...this.props}
                onMenuClick={this.handleOpen}
              >
                제휴 안내
              </RouterLink>
              <RouterLink
                to='/case'
                {...this.props}
                onMenuClick={this.handleOpen}
              >
                사장님 사례
              </RouterLink>
              <RouterLink
                to='/about'
                {...this.props}
                onMenuClick={this.handleOpen}
              >
                데이트팝 소개
              </RouterLink>
              <RouterLink
                to='/company'
                {...this.props}
                onMenuClick={this.handleOpen}
              >
                회사 소개
              </RouterLink>
              <RouterLink
                to='/contact'
                {...this.props}
                onMenuClick={this.handleOpen}
              >
                제휴 문의
              </RouterLink>
            </MobileMenu>
          </Container>
        </HeaderCenter>
      </HeaderWrapper>
    );
  }
}

const AppHeader = onClickOutside(Header);
export default withRender(AppHeader);
